export const routeAliases = {
  /* ───── DIRECT CATEGORY KEYS & QUERY PARAMS ───── */
  all: "all",
  "all-products": "all",
  shop: "all",
  collections: "all",
  "organic-food-india": "all",
  "pahadi-products-online": "all",
  "uttarakhand-food-products": "all",
  "traditional-kumaoni-food": "all",
  "organic-products-uttarakhand": "all",
  "organic-products-delhi": "all",
  "organic-products-india": "all",

  /* PICKLE */
  pickle: "pickle",
  pickles: "pickle",
  achar: "pickle",
  "pahadi-pickles": "pickle",
  "pahadi-achar": "pickle",
  "pahadi-achar-online": "pickle",
  "buy-pahadi-achar-online": "pickle",
  "nimbu-achar-online": "pickle",
  "homemade-pickle-india": "pickle",
  "buy-pahadi-achar": "pickle",
  "kumaoni-achar-online": "pickle",
  "buy-mango-pickle-online": "pickle",
  "homemade-pickles": "pickle",

  /* GHEE */
  ghee: "ghee",
  "desi-ghee": "ghee",
  "a2-ghee": "ghee",
  "cow-ghee": "ghee",
  "buy-desi-ghee-online": "ghee",
  "pure-desi-ghee-uttarakhand": "ghee",
  "bilona-ghee-online": "ghee",
  "bilona-ghee-uttarakhand": "ghee",
  "buy-a2-ghee-online": "ghee",
  "pure-desi-ghee-price-india": "ghee",
  "buy-organic-ghee-online-india": "ghee",

  /* HONEY */
  honey: "honey",
  "raw-honey": "honey",
  "pahadi-honey": "honey",
  "forest-honey": "honey",
  "raw-honey-uttarakhand": "honey",
  "buy-forest-honey-india": "honey",
  "organic-honey-online": "honey",
  "raw-honey-online-india": "honey",
  "organic-honey": "honey",

  /* SPICES */
  spices: "spices",
  spice: "spices",
  masala: "spices",
  "pahadi-spices": "spices",
  "pahadi-spices-online": "spices",
  "organic-masala-online": "spices",

  /* SALTS */
  pahadiSalts: "pahadiSalts",
  salt: "pahadiSalts",
  salts: "pahadiSalts",
  "herbal-salt": "pahadiSalts",
  "herbal-salts": "pahadiSalts",
  "pahadi-salt": "pahadiSalts",
  "pahadi-salts": "pahadiSalts",
  "himalayan-salt-india": "pahadiSalts",
  "sendha-namak-online": "pahadiSalts",

  /* DALS */
  pahadiDals: "pahadiDals",
  dal: "pahadiDals",
  dals: "pahadiDals",
  pulses: "pahadiDals",
  "pahadi-dals": "pahadiDals",
  "organic-dal-india": "pahadiDals",
  "pahadi-rajma-online": "pahadiDals",

  /* CHUTNEY */
  chutney: "chutney",
  chutneys: "chutney",
  "pahadi-chutney": "chutney",

  /* BEST SELLERS */
  new: "new",
  bestsellers: "new",
  "best-sellers": "new",
  "best-selling": "new",
  "most-loved": "new",
  "top-organic-products": "new",
  "trending-organic-products": "new",
};

export const preferredSlug = {
  all: "collections", // ✅ change from ""
  pickle: "pahadi-achar-online",
  ghee: "buy-desi-ghee-online",
  honey: "raw-honey-uttarakhand",
  spices: "pahadi-spices-online",
  pahadiSalts: "himalayan-salt-india",
  pahadiDals: "organic-dal-india",
  chutney: "pahadi-chutney",
  new: "best-sellers",
};
